import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  ApiUrls,
  AppConstants,
  AppDetails,
  SessionStorageKeys,
  UserCookie,
} from "../../utils/constants";
import {
  apiReqResLoader,
  checkEmptyVal,
  GetCookieValues,
  getInitials,
  getPagesPathByLoggedinUserProfile,
  GetUserCookieValues,
  UrlWithoutParam,
} from "../../utils/common";
import routes, { routeNames } from "../../routes/routes";
import { useAuth } from "../../contexts/AuthContext";
import { axiosPost } from "../../helpers/axiosHelper";
import config from "../../config.json";
import { deletesessionStorageItem } from "../../helpers/sessionStorageHelper";

const UserProfileMenu = (styleprops) => {
  const { logoutUser, loggedinUser } = useAuth();
  const navigate = useNavigate();
  const path = useLocation();

  let loggedinProfileTypeId = GetCookieValues(UserCookie.ProfileTypeId);
  let userCookieName = GetUserCookieValues(UserCookie.Name, loggedinUser);
  let userCookieProfiePic = GetUserCookieValues(
    UserCookie.ProfilePic,
    loggedinUser
  );

  const onLogout = (e) => {
    e.preventDefault();
    deletesessionStorageItem(SessionStorageKeys.CreateProfileId);
    apiReqResLoader("x");
    let objBodyParams = {
      accountid: GetUserCookieValues(UserCookie.AccountId, loggedinUser),
      devicetypeid: AppDetails.devicetypeid,
      sessionid: GetUserCookieValues(UserCookie.SessionId, loggedinUser),
    };

    axiosPost(`${config.apiBaseUrl}${ApiUrls.logout}`, objBodyParams)
      .then(() => {})
      .catch((err) => {
        console.error(`"API :: ${ApiUrls.logout}, Error ::" ${err}`);
      })
      .finally(() => {
        logoutUser();
        let routesList = routes.filter((r) => r.isprotected);
        let isprotectedRoute = routesList.filter(
          (rl) => rl.path.toLowerCase() == path.pathname.toLowerCase()
        )?.[0];

        if (isprotectedRoute == false || isprotectedRoute == undefined) {
          window.location.reload();
        } else {
          navigate(routeNames.home.path, { replace: true });
        }
        apiReqResLoader("x", "", "completed");
      });
  };

  const onUpgradePlan = () => {
    navigate(routeNames.upgradeplan.path);
  };

  const onChangeProfile = () => {
    navigate(routeNames.profiles.path);
  };

  const onNotifications = () => {
    navigate(
      getPagesPathByLoggedinUserProfile(loggedinProfileTypeId, "notifications")
    );
  };

  const onProfile = () => {
    navigate(
      loggedinProfileTypeId == 0
        ? UrlWithoutParam(routeNames.createprofile)
        : getPagesPathByLoggedinUserProfile(loggedinProfileTypeId, "profile")
    );
  };

  return (
    <>
      <li
        className={`nav-item user-info-nav-item ${
          styleprops?.style?.className === "publiclayout"
            ? " position-relative"
            : "pl-5"
        } ${styleprops?.style?.className}`}
      >
        <div
          className="nav-link user-option no-after-cnt pt-0"
          data-bs-toggle="collapse"
          data-bs-target="#collpase-widget-userinfo-menu"
          aria-controls="collpase-widget-userinfo-menu"
          aria-expanded="false"
        >
          <div className="d-flex lh-1">
            {userCookieProfiePic
              ?.toString()
              .toLowerCase()
              .indexOf("content/images/no-profile-pic.png") == -1 ? (
              <img
                src={userCookieProfiePic}
                alt=""
                className="shadow img-border-white"
              ></img>
            ) : (
              !checkEmptyVal(userCookieName) && (
                <div className="initials-pic flex-shrink-0 rounded-circle w-34px h-34px shadow bo-2-lihover lh-1 font-15 font-500 mr-10">
                  {getInitials(userCookieName)}
                </div>
              )
            )}
            {GetCookieValues(UserCookie.CountryId) != 0 && (
              <>
                <div className={`pt-1 user-info-name`}>
                  <div>{GetCookieValues(UserCookie.Name)}</div>
                  <div className="mt -1 small text-light">
                    {GetCookieValues(UserCookie.ProfileType)} -{" "}
                    {GetCookieValues(UserCookie.AccountType)}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <ul
          className={`dropdown-menu-arrow collapse in user-info-ddmenu ${
            styleprops?.style?.className === "condition" &&
            GetCookieValues(UserCookie.CountryId) === 0
              ? "condition"
              : ""
          }  bg-white position-absolute${
            styleprops?.style?.className === "publiclayout"
              ? " publiclayout"
              : ""
          } py-0 px-0 lh-1 shadow rounded`}
          id="collpase-widget-userinfo-menu"
          style={{ zIndex: styleprops?.style?.zIndex }}
        >
          <div className="row user-info-head py-10 px-10 mx-0 mb-10 box-shadow">
            <div className="container">
              <div className="row px-0">
                <div className="col px-0 wpx-50">
                  {/* <img
                    className="user-info-img shadow img-round"
                    src={GetCookieValues(UserCookie.ProfilePic)}
                    alt=""
                  ></img> */}
                  {GetCookieValues(UserCookie.ProfilePic)
                    ?.toString()
                    .toLowerCase()
                    .indexOf("content/images/no-profile-pic.png") == -1 ? (
                    <img
                      src={GetCookieValues(UserCookie.ProfilePic)}
                      alt=""
                      className="user-info-img shadow img-round img-border-white"
                    ></img>
                  ) : (
                    <div className="initials-pic flex-shrink-0 rounded-circle w-40px h-40px shadow bo-2-lihover lh-1 font-16 font-500 mr-10">
                      {getInitials(GetCookieValues(UserCookie.Name))}
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    styleprops?.style?.className === "condition" ||
                    GetCookieValues(UserCookie.CountryId) === 0
                      ? "d-flex align-items-center"
                      : ""
                  } col px-0 text-left`}
                >
                  <div className={`font-500 font-15 lh-20 text-primary`}>
                    {GetCookieValues(UserCookie.Name)}
                  </div>
                  {styleprops?.style?.className !== "condition" &&
                    GetCookieValues(UserCookie.CountryId) !== 0 && (
                      <div className="small text-light lh-1">
                        {GetCookieValues(UserCookie.ProfileType)} -{" "}
                        {GetCookieValues(UserCookie.AccountType)}
                      </div>
                    )}
                </div>
              </div>
              {styleprops?.style?.className !== "condition" &&
                GetCookieValues(UserCookie.CountryId) !== 0 && (
                  <div className="row px-0">
                    <div className="col px-0 wpx-50"></div>

                    <div className="col px-0 text-left flex-vc">
                      <div className="small text-primary lh-20 font-small">
                        {`${GetCookieValues(UserCookie.Plan)} Plan`}
                      </div>
                    </div>
                    <div className="col text-right px-0 w-120 flex-end">
                      <button
                        className="btn btn-primary btn-xs btn-round box-shadow btn-glow"
                        onClick={onUpgradePlan}
                      >
                        Upgrade
                      </button>
                    </div>
                  </div>
                )}
            </div>
          </div>
          {styleprops?.style?.className !== "condition" &&
          GetCookieValues(UserCookie.CountryId) !== 0 ? (
            <>
              <li className="dropdown-item">
                <a id="nav-user-info-dashboard" onClick={onProfile}>
                  <i className="fa fa-user pe-1"></i> My Profile
                </a>
              </li>
              <li className="dropdown-item">
                <Link id="nav-user-info-settings" to={routeNames.settings.path}>
                  <i className="fa fa-gear pe-1"></i> Settings
                </Link>
              </li>
              <li className="dropdown-item">
                <a id="nav-user-info-profiles" onClick={onChangeProfile}>
                  <i className="fa fa-exchange pe-1"></i> Manage Profiles
                </a>
              </li>
              <div className="dropdown-divider" />
              <div className="font-500 font-general px-10 py-10 text-gray">
                Notifications
              </div>
              <li className="dropdown-item">
                <a id="nav-user-info-notifications" onClick={onNotifications}>
                  <i className="fa fa-bell pe-1"></i> Notifications
                </a>
              </li>
              <li className="dropdown-item d-none">
                <a href="#!">
                  <i className="fa fa-envelope pe-1"></i> Messages
                </a>
              </li>
            </>
          ) : (
            <li className="dropdown-item">
              <a id="nav-user-info-dashboard" onClick={onProfile}>
                <i className="fa fa-user pe-1"></i> My Profile
              </a>
            </li>
          )}
          <div className="dropdown-divider" />
          <li className="dropdown-item">
            <a href="#!" onClick={onLogout}>
              <i className="fa fa-sign-out pe-1" aria-hidden="true"></i> Sign
              out
            </a>
          </li>
        </ul>
      </li>
    </>
  );
};

export default UserProfileMenu;
